module.exports = __webpack_public_path__ + "assets/img/11.af7aa91e.png";